<template>
  <div>
    <div class="orderId">
      订单ID {{ source.id }}
      <el-tag class="tag" v-if="source.customerId">{{ source.stateName }}</el-tag>
    </div>
    <column-box-expand :source="source" :list="baseInfoList" :separator="columnSeparator" label-width="max-content" />
  </div>
</template>
<script>
import { orderDetailCommonInfoV2 } from '@/api/domain/orders'

export default {
  name: 'CommonBaseInfo',
  props: {
    orderId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      source: {},
      baseInfoList: [
        {
          key: 'customerName',
          name: '司机姓名',
        },
        {
          key: 'idCard',
          name: '身份证号',
        },
        {
          key: 'tel',
          name: '手机号',
        },
        {
          key: 'customerId',
          name: '司机ID',
        },
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'modelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
      ],
    }
  },
  created() {
    this.orderDetails()
  },
  methods: {
    async orderDetails() {
      const { code, data } = await orderDetailCommonInfoV2({ orderId: this.orderId })
      if (code === 1) {
        this.source = data || {}
        // 如果司机id为0，显示--
        if (this.source.customerId === 0) {
          this.source.customerId = '--'
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.orderId {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  .tag {
    margin-left: 10px;
  }
}
</style>
